export function getRoute() {
  var _window$xy_vue_instan;
  return (_window$xy_vue_instan = window.xy_vue_instance) === null || _window$xy_vue_instan === void 0 ? void 0 : _window$xy_vue_instan.$route;
}
export function getRouter() {
  var _window$xy_vue_instan2;
  return (_window$xy_vue_instan2 = window.xy_vue_instance) === null || _window$xy_vue_instan2 === void 0 ? void 0 : _window$xy_vue_instan2.$router;
}
export function getRouteQuery() {
  var _getRoute$query, _getRoute;
  return (_getRoute$query = (_getRoute = getRoute()) === null || _getRoute === void 0 ? void 0 : _getRoute.query) !== null && _getRoute$query !== void 0 ? _getRoute$query : {};
}
export function getBranchId() {
  return getRouteQuery().branch;
}
export function getProjectId() {
  return getRouteQuery().projectid;
}
//# sourceMappingURL=router.js.map
